import Product = FBInstant.Product;
import { HudActions, HudEmitter } from '../../../../Managers/Hud/HudEmitter';

enum events {
    Purchase = 'purchase',
}

export abstract class ShopProduct extends PIXI.Container {
    public static events = events;
    protected readonly product: Product;
    protected bg: PIXI.Sprite;

    public get width() {
        return this.bg.width;
    }

    public get height() {
        return this.bg.height;
    }

    protected constructor(product: Product) {
        super();
        this.product = product;
    }

    protected buy() {
        this.emit(ShopProduct.events.Purchase, this.product);
        HudEmitter.instance.emit(HudActions.BUY_PRODUCT, this.product);
    }
}
